let mixin = {
  filters: {},
  methods: {
    // 图片前缀
    getImgSrc(img) {
      return "https://yygpro-oss.oss-cn-shenzhen.aliyuncs.com/images/" + img;
    },
    // 图片前缀
    ImgSrc(img) {
      return "https://yygpro-oss.oss-cn-shenzhen.aliyuncs.com/web/" + img;
    },
    getTreeData(data, childKey) {
      for (let i = 0; i < data.length; i++) {
        if (data[i][childKey].length < 1) {
          // children若为空数组，则将children设为undefined
          data[i][childKey] = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i][childKey], childKey);
        }
      }
      return data;
    },
  },
};

export default mixin;
